import React from 'react';
import V2PageNav from '../V2/Common/BreadCrumb/BreadCrumbs.component';

// Legacy global breadcrumb — now thin shim over the V2 PageNav component.
// Renders a back-button when childrenObj has a parent entry; otherwise
// renders nothing. The page-title heading and breadcrumb trail were
// dropped intentionally per design decision.
export default function Breadcrumbs(props) {
  return <V2PageNav childrenObj={props.childrenObj} />;
}
